<section class="cycle-planet-grid" [class.cycle-planet-grid--personality-only]="personalityOnly()">
  <h3 class="cycle-planet-grid__title">{{ title() }}</h3>
  <div class="cycle-planet-grid__rows">
    @for (row of rows(); track row.displayConfig.key) {
      <div class="cycle-planet-grid__row" [attr.data-planet-key]="row.displayConfig.key">
        @if (!personalityOnly()) {
          <!-- Linkerflank: keynotes van de design-activatie (rechts uitgelijnd tegen de cel). -->
          <div class="cycle-planet-grid__flank cycle-planet-grid__flank--design">
            @if (row.designAnnotation; as annotation) {
              <ng-container [ngTemplateOutlet]="annotationLines"
                            [ngTemplateOutletContext]="{ $implicit: annotation }"></ng-container>
            }
          </div>

          <div class="cycle-planet-grid__cell">
            <hd-just-now-planet-activation-cell
              [activation]="row.designActivation"
              kind="design"
              [fixing]="row.designFixing?.baseFixing ?? 'none'"
              [transitFixing]="row.designFixing?.transitFixing ?? 'none'"
              [transitTooltip]="transitTooltip(row.designFixing)"
              [contextMenuEnabled]="false"
              (activationClicked)="onActivationClicked($event)"
            />
          </div>
        }
        <span class="cycle-planet-grid__glyph">{{ row.displayConfig.astronomiconChar }}</span>
        <div class="cycle-planet-grid__cell">
          <hd-just-now-planet-activation-cell
            [activation]="row.personalityActivation"
            kind="personality"
            [fixing]="row.personalityFixing?.baseFixing ?? 'none'"
            [transitFixing]="row.personalityFixing?.transitFixing ?? 'none'"
            [transitTooltip]="transitTooltip(row.personalityFixing)"
            [contextMenuEnabled]="false"
            (activationClicked)="onActivationClicked($event)"
          />
        </div>

        <!-- Rechterflank: keynotes van de personality-activatie. -->
        <div class="cycle-planet-grid__flank cycle-planet-grid__flank--personality">
          @if (row.personalityAnnotation; as annotation) {
            <ng-container [ngTemplateOutlet]="annotationLines"
                          [ngTemplateOutletContext]="{ $implicit: annotation }"></ng-container>
          }
        </div>
      </div>
    }

    @if ((!personalityOnly() && designChiron()) || personalityChiron()) {
      <div class="cycle-planet-grid__row cycle-planet-grid__row--chiron" data-planet-key="chiron">
        @if (!personalityOnly()) {
          <div class="cycle-planet-grid__flank cycle-planet-grid__flank--design"></div>
          <div class="cycle-planet-grid__cell">
            @if (designChiron(); as chironVm) {
              <span class="cycle-planet-grid__chiron-value" [title]="chironVm.tooltip">{{ chironVm.gate }}.{{ chironVm.line }}</span>
            }
          </div>
        }
        <span class="cycle-planet-grid__glyph" [title]="(designChiron() ?? personalityChiron())?.tooltip ?? null">{{ (designChiron() ?? personalityChiron())?.glyph }}</span>
        <div class="cycle-planet-grid__cell">
          @if (personalityChiron(); as chironVm) {
            <span class="cycle-planet-grid__chiron-value" [title]="chironVm.tooltip">{{ chironVm.gate }}.{{ chironVm.line }}</span>
          }
        </div>
        <div class="cycle-planet-grid__flank cycle-planet-grid__flank--personality"></div>
      </div>
    }
  </div>
</section>

<!-- Keynote-flank: regel 1 = main-rollen (met kanaal-tooltip) + Tegenkoming/Vernieuwing,
     regel 2 = planeet-groep. Multi-rol poorten tonen elke rol als eigen chip. -->
<ng-template #annotationLines let-annotation>
  <span class="cycle-planet-grid__flank-line">
    @for (main of annotation.mains; track main.label) {
      <span class="cycle-planet-grid__keynote cycle-planet-grid__keynote--main"
            [style.--keynote-color]="main.color"
            [attr.title]="main.tooltip || null">
        @if (main.icon) {
          <i class="fas fa-{{ main.icon }}" aria-hidden="true"></i>
        }
        <span>{{ main.label }}</span>
      </span>
      <span class="cycle-planet-grid__keynote-sep" aria-hidden="true">·</span>
    }
    <span class="cycle-planet-grid__keynote" [attr.title]="annotation.encounterTooltip || null">
      <i class="fas fa-{{ annotation.encounterIcon }}" aria-hidden="true"></i>
      <span>{{ annotation.encounterLabel }}</span>
    </span>
  </span>
  @if (annotation.groupLabel) {
    <span class="cycle-planet-grid__flank-line cycle-planet-grid__flank-line--group">
      <span class="cycle-planet-grid__keynote cycle-planet-grid__keynote--group">
        @if (annotation.groupIcon) {
          <i class="fas fa-{{ annotation.groupIcon }}" aria-hidden="true"></i>
        }
        <span>{{ annotation.groupLabel }}</span>
      </span>
    </span>
  }
</ng-template>
